module.exports = __webpack_public_path__ + "img/train.ffea9a82.svg";